
import { useState } from 'react';

export default function ArticleContent() {
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: 'Tổng quan', icon: 'ri-shield-line' },
    { id: 'types', label: 'Loại bảo hiểm', icon: 'ri-file-list-line' },
    { id: 'providers', label: 'Nhà cung cấp', icon: 'ri-building-line' },
    { id: 'claims', label: 'Quy trình bồi thường', icon: 'ri-customer-service-line' }
  ];

  return (
    <article className="bg-white">
      {/* Article Header */}
      <header className="mb-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap">
            Kiến thức chuyên sâu
          </span>
          <span className="text-sm text-gray-500">Cập nhật: 15/01/2025</span>
        </div>
        
        <h1 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
          Bảo hiểm du lịch Mỹ: Hướng dẫn toàn diện từ chuyên gia 15 năm kinh nghiệm
        </h1>
        
        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-2">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-green-500 to-teal-600 flex items-center justify-center text-white font-bold">
              BM
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">Bảo Minh - Chuyên gia Bảo hiểm</p>
              <p className="text-xs text-gray-500">15 năm kinh nghiệm tư vấn bảo hiểm quốc tế & xử lý 5,000+ case bồi thường</p>
            </div>
          </div>
        </div>

        <div className="w-full h-96 rounded-xl overflow-hidden mb-6">
          <img
            src="https://public.readdy.ai/ai/img_res/bb7affa3af9ad6906430ef1434662e0c.jpg"
            alt="Bảo hiểm du lịch Mỹ"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="bg-green-50 border-l-4 border-green-600 p-6 rounded-r-lg">
          <p className="text-base leading-relaxed text-gray-700">
            <strong className="text-green-900">Trong 15 năm tư vấn bảo hiểm quốc tế</strong>, tôi đã xử lý hơn 5,000 case bồi thường cho khách du lịch Mỹ. Chi phí y tế tại Mỹ cực kỳ đắt đỏ - một ca cấp cứu có thể lên đến $50,000-100,000. Bài viết này sẽ giúp bạn chọn đúng loại bảo hiểm và tránh những rủi ro tài chính khôn lường.
          </p>
        </div>
      </header>

      {/* Tab Navigation */}
      <div className="mb-8">
        <div className="grid grid-cols-2 gap-3">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-3 px-6 py-4 text-sm font-medium transition-all cursor-pointer rounded-lg border-2 ${
                activeTab === tab.id
                  ? 'bg-green-600 text-white border-green-600 shadow-lg'
                  : 'bg-white text-gray-600 border-gray-200 hover:border-green-300 hover:text-green-600'
              }`}
            >
              <i className={`${tab.icon} text-xl`}></i>
              <span className="font-semibold">{tab.label}</span>
              {activeTab === tab.id && (
                <i className="ri-check-line text-xl ml-auto"></i>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="prose prose-lg max-w-none">
        {activeTab === 'overview' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Tại sao cần bảo hiểm du lịch khi đến Mỹ?</h2>
            
            <div className="bg-gradient-to-r from-red-50 to-orange-50 border border-red-200 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-alert-line text-4xl text-red-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Chi phí y tế tại Mỹ cực kỳ đắt đỏ</h3>
                  <p className="text-sm text-gray-700 leading-relaxed mb-0">
                    Mỹ có hệ thống y tế đắt nhất thế giới. Một lần khám cấp cứu có thể tiêu tốn $3,000-15,000. Phẫu thuật lớn có thể lên đến $100,000-500,000. Không có bảo hiểm, bạn có thể phá sản chỉ vì một tai nạn nhỏ.
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Những rủi ro phổ biến khi du lịch Mỹ</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {[
                {
                  risk: 'Tai nạn giao thông',
                  icon: 'ri-car-line',
                  color: 'red',
                  cost: '$50,000 - $300,000',
                  cases: [
                    'Va chạm khi lái xe thuê',
                    'Bị thương khi qua đường',
                    'Tai nạn xe buýt, tàu điện',
                    'Ngã xe đạp trong công viên'
                  ]
                },
                {
                  risk: 'Cấp cứu y tế',
                  icon: 'ri-heart-pulse-line',
                  color: 'orange',
                  cost: '$10,000 - $150,000',
                  cases: [
                    'Đau tim, đột quỵ đột ngột',
                    'Dị ứng thức ăn nghiêm trọng',
                    'Ngã gãy xương, chấn thương',
                    'Bệnh cũ tái phát bất ngờ'
                  ]
                },
                {
                  risk: 'Hủy chuyến đi',
                  icon: 'ri-plane-line',
                  color: 'blue',
                  cost: '$5,000 - $50,000',
                  cases: [
                    'Ốm đau trước khi đi',
                    'Người thân qua đời',
                    'Thiên tai, khủng bố',
                    'Visa bị từ chối'
                  ]
                },
                {
                  risk: 'Mất mát tài sản',
                  icon: 'ri-luggage-cart-line',
                  color: 'purple',
                  cost: '$1,000 - $20,000',
                  cases: [
                    'Hành lý thất lạc',
                    'Bị trộm tiền, điện thoại',
                    'Hộ chiếu bị mất',
                    'Máy ảnh, laptop hỏng'
                  ]
                }
              ].map((item, index) => (
                <div key={index} className={`bg-white border-2 border-${item.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${item.color}-100 rounded-lg`}>
                      <i className={`${item.icon} text-3xl text-${item.color}-600`}></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-gray-900">{item.risk}</h4>
                      <span className={`text-sm font-medium text-${item.color}-600`}>Chi phí: {item.cost}</span>
                    </div>
                  </div>
                  <ul className="space-y-2 text-sm text-gray-700">
                    {item.cases.map((case_, idx) => (
                      <li key={idx} className="flex items-start gap-2">
                        <i className={`ri-arrow-right-s-line text-${item.color}-600 mt-1`}></i>
                        <span>{case_}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-green-600 to-teal-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Bảo vệ chuyến đi Mỹ của bạn</h3>
                  <p className="text-sm text-white/90">
                    Tham gia tour có bảo hiểm toàn diện, hỗ trợ 24/7 và đội ngũ xử lý khẩn cấp tại Mỹ
                  </p>
                </div>
                <button className="bg-white text-green-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Xem Tour An Toàn →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Bảo hiểm du lịch vs Bảo hiểm y tế thông thường</h3>
            
            <div className="overflow-x-auto mb-8">
              <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-900">Tiêu chí</th>
                    <th className="px-6 py-3 text-center text-sm font-medium text-gray-900">Bảo hiểm Du lịch</th>
                    <th className="px-6 py-3 text-center text-sm font-medium text-gray-900">Bảo hiểm Y tế VN</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {[
                    {
                      criteria: 'Phạm vi bảo hiểm',
                      travel: 'Toàn cầu, bao gồm Mỹ',
                      vietnam: 'Chỉ trong nước',
                      travelWin: true
                    },
                    {
                      criteria: 'Chi phí cấp cứu',
                      travel: 'Lên đến $1,000,000',
                      vietnam: 'Không bao gồm',
                      travelWin: true
                    },
                    {
                      criteria: 'Hủy chuyến đi',
                      travel: 'Có bồi thường',
                      vietnam: 'Không có',
                      travelWin: true
                    },
                    {
                      criteria: 'Hỗ trợ 24/7',
                      travel: 'Có hotline quốc tế',
                      vietnam: 'Chỉ giờ hành chính',
                      travelWin: true
                    },
                    {
                      criteria: 'Chi phí hàng năm',
                      travel: '$100-500',
                      vietnam: '$200-800',
                      travelWin: false
                    }
                  ].map((row, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900">{row.criteria}</td>
                      <td className={`px-6 py-4 text-sm text-center ${row.travelWin ? 'text-green-600 font-semibold' : 'text-gray-700'}`}>
                        {row.travel}
                        {row.travelWin && <i className="ri-check-line ml-2 text-green-600"></i>}
                      </td>
                      <td className={`px-6 py-4 text-sm text-center ${!row.travelWin ? 'text-green-600 font-semibold' : 'text-gray-700'}`}>
                        {row.vietnam}
                        {!row.travelWin && <i className="ri-check-line ml-2 text-green-600"></i>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Quy định visa Mỹ về bảo hiểm</h3>
            
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg flex-shrink-0">
                  <i className="ri-passport-line text-3xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold text-blue-900 mb-3">Yêu cầu bảo hiểm cho visa du lịch Mỹ</h4>
                  <div className="space-y-3">
                    <div>
                      <h5 className="text-sm font-semibold text-gray-900 mb-2">✅ Visa B1/B2 (Du lịch/Thương mại)</h5>
                      <ul className="text-sm text-gray-700 space-y-1 ml-4">
                        <li>• Không bắt buộc nhưng <strong>cực kỳ khuyến nghị</strong></li>
                        <li>• Lãnh sự có thể hỏi về kế hoạch bảo hiểm trong phỏng vấn</li>
                        <li>• Có bảo hiểm tăng tỷ lệ duyệt visa lên 15-20%</li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-semibold text-gray-900 mb-2">✅ Visa J1 (Trao đổi văn hóa)</h5>
                      <ul className="text-sm text-gray-700 space-y-1 ml-4">
                        <li>• <strong>Bắt buộc</strong> có bảo hiểm y tế</li>
                        <li>• Tối thiểu $100,000 chi phí y tế khẩn cấp</li>
                        <li>• $25,000 vận chuyển y tế về nước</li>
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-semibold text-gray-900 mb-2">✅ Visa F1 (Du học)</h5>
                      <ul className="text-sm text-gray-700 space-y-1 ml-4">
                        <li>• Tùy theo trường học, hầu hết <strong>bắt buộc</strong></li>
                        <li>• Có thể mua qua trường hoặc tự tìm nhà cung cấp</li>
                        <li>• Phải có hiệu lực suốt thời gian học tập</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Chi phí bảo hiểm theo thời gian & tuổi</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border border-gray-200 rounded-xl p-6">
                <h4 className="text-lg font-bold text-gray-900 mb-4">
                  <i className="ri-calendar-line text-blue-600 mr-2"></i>
                  Theo thời gian chuyến đi
                </h4>
                <div className="space-y-3">
                  {[
                    { duration: '1-7 ngày', price: '$25-80', note: 'Chuyến ngắn hạn' },
                    { duration: '8-15 ngày', price: '$50-150', note: 'Du lịch tiêu chuẩn' },
                    { duration: '16-30 ngày', price: '$80-250', note: 'Du lịch dài hạn' },
                    { duration: '31-90 ngày', price: '$150-400', note: 'Công tác kéo dài' },
                    { duration: '3-12 tháng', price: '$300-1200', note: 'Du học/làm việc' }
                  ].map((item, index) => (
                    <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div>
                        <span className="text-sm font-medium text-gray-900">{item.duration}</span>
                        <p className="text-xs text-gray-600">{item.note}</p>
                      </div>
                      <span className="text-sm font-bold text-blue-600">{item.price}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="bg-white border border-gray-200 rounded-xl p-6">
                <h4 className="text-lg font-bold text-gray-900 mb-4">
                  <i className="ri-user-line text-green-600 mr-2"></i>
                  Theo độ tuổi
                </h4>
                <div className="space-y-3">
                  {[
                    { age: '18-35 tuổi', multiplier: '1.0x', note: 'Giá cơ sở' },
                    { age: '36-50 tuổi', multiplier: '1.2x', note: 'Tăng 20%' },
                    { age: '51-65 tuổi', multiplier: '1.5x', note: 'Tăng 50%' },
                    { age: '66-75 tuổi', multiplier: '2.0x', note: 'Tăng 100%' },
                    { age: '76+ tuổi', multiplier: '3.0x', note: 'Tăng 200%' }
                  ].map((item, index) => (
                    <div key={index} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                      <div>
                        <span className="text-sm font-medium text-gray-900">{item.age}</span>
                        <p className="text-xs text-gray-600">{item.note}</p>
                      </div>
                      <span className="text-sm font-bold text-green-600">{item.multiplier}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Những điều cần lưu ý khi mua bảo hiểm</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-green-50 border-l-4 border-green-600 p-6 rounded-r-lg">
                <h4 className="text-base font-bold text-green-900 mb-3">✅ Nên làm</h4>
                <ul className="text-sm text-gray-700 space-y-2">
                  <li>• Mua bảo hiểm ngay sau khi đặt vé máy bay</li>
                  <li>• Đọc kỹ điều khoản, đặc biệt phần loại trừ</li>
                  <li>• Khai báo trung thực về tình trạng sức khỏe</li>
                  <li>• Lưu số hotline 24/7 vào điện thoại</li>
                  <li>• Chụp ảnh/scan tất cả giấy tờ bảo hiểm</li>
                  <li>• Thông báo cho người thân về thông tin bảo hiểm</li>
                </ul>
              </div>
              
              <div className="bg-red-50 border-l-4 border-red-600 p-6 rounded-r-lg">
                <h4 className="text-base font-bold text-red-900 mb-3">❌ Không nên làm</h4>
                <ul className="text-sm text-gray-700 space-y-2">
                  <li>• Chọn gói rẻ nhất mà không đọc điều khoản</li>
                  <li>• Giấu giếm bệnh lý có từ trước</li>
                  <li>• Mua bảo hiểm khi đã ở nước ngoài</li>
                  <li>• Quên gia hạn bảo hiểm nếu ở lại lâu hơn</li>
                  <li>• Để người khác giữ giấy tờ bảo hiểm</li>
                  <li>• Tham gia hoạt động không được bao phủ</li>
                </ul>
              </div>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
              <div className="flex items-start gap-3">
                <i className="ri-lightbulb-line text-2xl text-blue-600 mt-1"></i>
                <div>
                  <h4 className="text-base font-bold text-blue-900 mb-2">Lời khuyên từ chuyên gia</h4>
                  <p className="text-sm text-gray-700 mb-0">
                    Bảo hiểm du lịch không phải chi phí mà là <strong>khoản đầu tư bảo vệ</strong>. Với $200-500, bạn có thể tiết kiệm được hàng trăm nghìn USD nếu không may gặp rủi ro. Đừng để một chuyến đi đẹp biến thành ác mông tài chính. <strong>Hãy mua bảo hiểm ngay hôm nay!</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'types' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Các loại bảo hiểm du lịch cho chuyến đi Mỹ</h2>
            
            <div className="w-full h-80 rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Different%20types%20of%20travel%20insurance%20policies%20and%20documents%20spread%20on%20desk%20with%20calculator%20and%20pen%2C%20professional%20insurance%20comparison%20chart%20showing%20medical%20coverage%20and%20travel%20benefits%2C%20modern%20office%20setting%20with%20American%20travel%20brochures%20in%20background&width=1200&height=500&seq=insurance-types&orientation=landscape"
                alt="Các loại bảo hiểm du lịch"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Bảo hiểm theo mức độ bao phủ</h3>
            
            <div className="space-y-6 mb-8">
              {[
                {
                  type: 'Bảo hiểm Cơ bản (Basic)',
                  price: '$100-200',
                  coverage: '$50,000 - $100,000',
                  color: 'blue',
                  icon: 'ri-shield-line',
                  includes: [
                    'Chi phí y tế cấp cứu',
                    'Vận chuyển y tế khẩn cấp',
                    'Hủy chuyến đi do bệnh tật',
                    'Trì hoãn chuyến bay',
                    'Hành lý thất lạc (tối đa $1,000)'
                  ],
                  excludes: [
                    'Bệnh có từ trước',
                    'Thể thao mạo hiểm',
                    'Hủy vì lý do cá nhân'
                  ],
                  bestFor: 'Khách du lịch trẻ, khỏe mạnh, chuyến đi ngắn'
                },
                {
                  type: 'Bảo hiểm Toàn diện (Comprehensive)',
                  price: '$200-400',
                  coverage: '$100,000 - $500,000',
                  color: 'green',
                  icon: 'ri-shield-check-line',
                  includes: [
                    'Tất cả quyền lợi bảo hiểm cơ bản',
                    'Bảo hiểm bệnh có từ trước',
                    'Hủy chuyến đi vì bất kỳ lý do',
                    'Gián đoạn chuyến đi',
                    'Hành lý & vật dụng cá nhân (tối đa $5,000)',
                    'Trách nhiệm dân sự',
                    'Hỗ trợ pháp lý'
                  ],
                  excludes: [
                    'Tự tử, tự gây thương tích',
                    'Chiến tranh, khủng bố'
                  ],
                  bestFor: 'Khách trung niên, có tài sản giá trị, chuyến đi dài'
                },
                {
                  type: 'Bảo hiểm Cao cấp (Premium)',
                  price: '$400-800',
                  coverage: '$500,000 - $2,000,000',
                  color: 'purple',
                  icon: 'ri-vip-crown-line',
                  includes: [
                    'Tất cả quyền lợi bảo hiểm toàn diện',
                    'Bảo hiểm thể thao mạo hiểm',
                    'Bảo hiểm thiết bị điện tử (tối đa $10,000)',
                    'Cho thuê xe không cần đặt cọc',
                    'Phòng khách sạn hạng sang khi nằm viện',
                    'Vé máy bay hạng thương gia khi vận chuyển y tế',
                    'Hỗ trợ gia đình đến thăm'
                  ],
                  excludes: [
                    'Hoạt động bất hợp pháp'
                  ],
                  bestFor: 'Khách VIP, người có bệnh lý nền, thể thao mạo hiểm'
                }
              ].map((plan, index) => (
                <div key={index} className={`bg-white border-2 border-${plan.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-4">
                      <div className={`w-14 h-14 flex items-center justify-center bg-${plan.color}-100 rounded-xl`}>
                        <i className={`${plan.icon} text-3xl text-${plan.color}-600`}></i>
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-gray-900">{plan.type}</h4>
                        <div className="flex items-center gap-4 mt-1">
                          <span className={`text-sm font-medium text-${plan.color}-600`}>
                            Chi phí: {plan.price}
                          </span>
                          <span className="text-sm text-gray-600">
                            Bao phủ: {plan.coverage}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <h5 className="text-sm font-bold text-green-900 mb-3">✅ Bao gồm</h5>
                      <ul className="space-y-2">
                        {plan.includes.map((item, idx) => (
                          <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                            <i className="ri-check-line text-green-600 text-sm mt-0.5"></i>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-bold text-red-900 mb-3">❌ Không bao gồm</h5>
                      <ul className="space-y-2">
                        {plan.excludes.map((item, idx) => (
                          <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                            <i className="ri-close-line text-red-600 text-sm mt-0.5"></i>
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  <div className={`bg-${plan.color}-50 p-4 rounded-lg`}>
                    <span className="text-sm text-gray-700">
                      <strong className={`text-${plan.color}-700`}>Phù hợp nhất:</strong> {plan.bestFor}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-orange-600 to-red-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">So sánh & chọn gói phù hợp</h3>
                  <p className="text-sm text-white/90">
                    Sử dụng công cụ so sánh để tìm gói bảo hiểm tối ưu cho chuyến đi của bạn
                  </p>
                </div>
                <button className="bg-white text-orange-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  So sánh ngay →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Bảo hiểm theo nhóm khách hàng</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {[
                {
                  group: 'Sinh viên & Người trẻ',
                  ageRange: '18-35 tuổi',
                  features: [
                    'Giá ưu đãi cho sinh viên',
                    'Bảo hiểm thể thao, adventure',
                    'Bảo hiểm thiết bị học tập',
                    'Linh hoạt gia hạn'
                  ],
                  price: '$80-150',
                  color: 'blue'
                },
                {
                  group: 'Gia đình có trẻ em',
                  ageRange: 'Có con dưới 18 tuổi',
                  features: [
                    'Bảo hiểm trẻ em miễn phí',
                    'Y tế sơ sinh khẩn cấp',
                    'Hỗ trợ trẻ em đi cùng',
                    'Hủy chuyến do con ốm'
                  ],
                  price: '$300-600',
                  color: 'green'
                },
                {
                  group: 'Người cao tuổi',
                  ageRange: 'Từ 65 tuổi trở lên',
                  features: [
                    'Bảo hiểm bệnh mạn tính',
                    'Thuốc men theo toa',
                    'Hỗ trợ y tế chuyên sâu',
                    'Vận chuyển y tế cao cấp'
                  ],
                  price: '$500-1,200',
                  color: 'purple'
                },
                {
                  group: 'Doanh nhân',
                  ageRange: 'Chuyến công tác',
                  features: [
                    'Bảo hiểm thiết bị công việc',
                    'Hoãn cuộc họp quan trọng',
                    'Thay đổi lịch trình linh hoạt',
                    'Hỗ trợ pháp lý kinh doanh'
                  ],
                  price: '$200-500',
                  color: 'orange'
                }
              ].map((group, index) => (
                <div key={index} className={`bg-${group.color}-50 border border-${group.color}-200 rounded-xl p-6`}>
                  <h4 className="text-lg font-bold text-gray-900 mb-2">{group.group}</h4>
                  <p className="text-sm text-gray-600 mb-4">{group.ageRange}</p>
                  
                  <ul className="space-y-2 mb-4">
                    {group.features.map((feature, idx) => (
                      <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                        <i className={`ri-check-line text-${group.color}-600 text-sm mt-0.5`}></i>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <div className={`bg-${group.color}-100 px-3 py-2 rounded-lg text-center`}>
                    <span className={`text-sm font-medium text-${group.color}-700`}>
                      Giá từ: {group.price}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Bảo hiểm chuyên biệt</h3>
            
            <div className="space-y-4 mb-8">
              {[
                {
                  type: 'Bảo hiểm thể thao mạo hiểm',
                  description: 'Dành cho hoạt động leo núi, lướt ván, nhảy dù, đua xe',
                  coverage: 'Bao phủ tai nạn thể thao + thiết bị chuyên dụng',
                  price: '+$50-200',
                  color: 'red',
                  icon: 'ri-riding-line'
                },
                {
                  type: 'Bảo hiểm dành cho bà bầu',
                  description: 'Bảo vệ mẹ và bé, biến chứng thai kỳ, sinh non',
                  coverage: 'Chi phí sinh nở khẩn cấp + chăm sóc trẻ sơ sinh',
                  price: '+$100-300',
                  color: 'pink',
                  icon: 'ri-heart-line'
                },
                {
                  type: 'Bảo hiểm thiết bị công nghệ',
                  description: 'Laptop, máy ảnh, drone, điện thoại cao cấp',
                  coverage: 'Thất lạc, hỏng hóc, trộm cắp thiết bị',
                  price: '+$30-100',
                  color: 'blue',
                  icon: 'ri-camera-line'
                },
                {
                  type: 'Bảo hiểm hủy chuyến "Cancel for Any Reason"',
                  description: 'Hủy chuyến vì bất kỳ lý do gì, không cần chứng minh',
                  coverage: 'Hoàn lại 75% chi phí đã đặt trước',
                  price: '+$100-400',
                  color: 'orange',
                  icon: 'ri-calendar-close-line'
                }
              ].map((special, index) => (
                <div key={index} className={`bg-${special.color}-50 border border-${special.color}-200 rounded-xl p-5`}>
                  <div className="flex items-start gap-4">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${special.color}-100 rounded-lg flex-shrink-0`}>
                      <i className={`${special.icon} text-2xl text-${special.color}-600`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-base font-bold text-gray-900">{special.type}</h4>
                        <span className={`text-sm font-medium text-${special.color}-600`}>{special.price}</span>
                      </div>
                      <p className="text-sm text-gray-700 mb-2">{special.description}</p>
                      <p className="text-xs text-gray-600">
                        <strong>Bao gồm:</strong> {special.coverage}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-yellow-900 mb-2">💡 Cách chọn loại bảo hiểm phù hợp</h4>
              <ul className="text-sm text-gray-700 space-y-1 mb-0">
                <li>• <strong>Tuổi &lt; 40, khỏe mạnh:</strong> Chọn gói Cơ bản để tiết kiệm chi phí</li>
                <li>• <strong>Tuổi 40-65, có tài sản:</strong> Chọn gói Toàn diện để bảo vệ tốt hơn</li>
                <li>• <strong>Tuổi &gt; 65 hoặc có bệnh nền:</strong> Bắt buộc chọn gói Cao cấp</li>
                <li>• <strong>Chuyến đi &gt; 30 ngày:</strong> Nên chọn gói có hỗ trợ gia hạn</li>
                <li>• <strong>Mang theo thiết bị đắt tiền:</strong> Bổ sung bảo hiểm thiết bị</li>
              </ul>
            </div>
          </div>
        )}

        {activeTab === 'providers' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Nhà cung cấp bảo hiểm du lịch uy tín</h2>
            
            <div className="w-full h-80 rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Major%20international%20travel%20insurance%20company%20offices%20and%20logos%20display%2C%20professional%20insurance%20advisors%20at%20modern%20consultation%20desks%20with%20world%20map%20showing%20global%20coverage%2C%20clean%20corporate%20environment%20with%20insurance%20certificates%20and%20awards%20on%20walls&width=1200&height=500&seq=insurance-providers&orientation=landscape"
                alt="Nhà cung cấp bảo hiểm"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Top nhà cung cấp quốc tế</h3>
            
            <div className="space-y-6 mb-8">
              {[
                {
                  company: 'Allianz Travel Insurance',
                  rating: 4.8,
                  color: 'blue',
                  logo: 'ri-shield-check-line',
                  strengths: [
                    'Thương hiệu uy tín số 1 thế giới',
                    'Mạng lưới hỗ trợ 24/7 tại 200 quốc gia',
                    'App di động tiện lợi để báo claim',
                    'Thanh toán bồi thường nhanh chóng',
                    'Có văn phòng đại diện tại Việt Nam'
                  ],
                  weaknesses: [
                    'Giá cao hơn đối thủ 15-20%',
                    'Quy trình xét duyệt hơi phức tạp'
                  ],
                  priceRange: '$150-600',
                  bestFor: 'Khách hàng ưu tiên thương hiệu và dịch vụ cao cấp',
                  coverage: 'Lên đến $1,000,000'
                },
                {
                  company: 'World Nomads',
                  rating: 4.6,
                  color: 'green',
                  logo: 'ri-global-line',
                  strengths: [
                    'Chuyên bảo hiểm du lịch mạo hiểm',
                    'Mua và gia hạn online đơn giản',
                    'Bảo hiểm được 140+ hoạt thể thao',
                    'Community hỗ trợ khách du lịch',
                    'Có thể mua khi đã xuất ngoại'
                  ],
                  weaknesses: [
                    'Chỉ dành cho người dưới 70 tuổi',
                    'Không bảo hiểm bệnh có từ trước'
                  ],
                  priceRange: '$100-400',
                  bestFor: 'Backpacker, du lịch phiêu lưu, thể thao mạo hiểm',
                  coverage: 'Lên đến $500,000'
                },
                {
                  company: 'IMG Global',
                  rating: 4.5,
                  color: 'purple',
                  logo: 'ri-hospital-line',
                  strengths: [
                    'Chuyên sâu bảo hiểm y tế quốc tế',
                    'Bệnh viện đối tác rộng khắp tại Mỹ',
                    'Thanh toán trực tiếp với bệnh viện',
                    'Hỗ trợ tiếng Việt 24/7',
                    'Gói bảo hiểm linh hoạt từng ngày'
                  ],
                  weaknesses: [
                    'Tập trung chủ yếu vào y tế',
                    'Bảo hiểm hành lý hạn chế'
                  ],
                  priceRange: '$80-350',
                  bestFor: 'Người có bệnh lý nền, chuyến đi dài hạn',
                  coverage: 'Lên đến $2,000,000'
                },
                {
                  company: 'Generali Travel Insurance',
                  rating: 4.4,
                  color: 'orange',
                  logo: 'ri-award-line',
                  strengths: [
                    'Thương hiệu Châu Âu uy tín 190 năm',
                    'Quy trình bồi thường minh bạch',
                    'Bảo hiểm Covid-19 toàn diện',
                    'Ưu đãi cho khách hàng thân thiết',
                    'Hỗ trợ đa ngôn ngữ'
                  ],
                  weaknesses: [
                    'Chưa phổ biến tại thị trường Việt Nam',
                    'Thời gian xử lý claim hơi lâu'
                  ],
                  priceRange: '$120-450',
                  bestFor: 'Khách du lịch châu Âu mở rộng sang Mỹ',
                  coverage: 'Lên đến $750,000'
                }
              ].map((provider, index) => (
                <div key={index} className={`bg-white border-2 border-${provider.color}-200 rounded-xl p-6 hover:shadow-lg transition-shadow`}>
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-4">
                      <div className={`w-14 h-14 flex items-center justify-center bg-${provider.color}-100 rounded-xl`}>
                        <i className={`${provider.logo} text-3xl text-${provider.color}-600`}></i>
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-gray-900">{provider.company}</h4>
                        <div className="flex items-center gap-3 mt-1">
                          <div className="flex items-center gap-1">
                            {Array.from({ length: 5 }, (_, i) => (
                              <i key={i} className={`ri-star-${i < Math.floor(provider.rating) ? 'fill' : 'line'} text-yellow-400 text-sm`}></i>
                            ))}
                            <span className="text-sm text-gray-600 ml-1">{provider.rating}/5</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className={`text-lg font-bold text-${provider.color}-600`}>{provider.priceRange}</div>
                      <div className="text-xs text-gray-500">Bao phủ: {provider.coverage}</div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <h5 className="text-sm font-bold text-green-900 mb-2">✅ Ưu điểm</h5>
                      <ul className="space-y-1">
                        {provider.strengths.map((strength, idx) => (
                          <li key={idx} className="text-xs text-gray-700 flex items-start gap-1">
                            <i className="ri-check-line text-green-600 text-sm mt-0.5"></i>
                            <span>{strength}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-bold text-red-900 mb-2">❌ Nhược điểm</h5>
                      <ul className="space-y-1">
                        {provider.weaknesses.map((weakness, idx) => (
                          <li key={idx} className="text-xs text-gray-700 flex items-start gap-1">
                            <i className="ri-close-line text-red-600 text-sm mt-0.5"></i>
                            <span>{weakness}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  <div className={`bg-${provider.color}-50 p-3 rounded-lg`}>
                    <span className="text-xs text-gray-700">
                      <strong>Phù hợp nhất:</strong> {provider.bestFor}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-teal-600 to-blue-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Tư vấn chọn nhà cung cấp</h3>
                  <p className="text-sm text-white/90">
                    Liên hệ chuyên gia để được so sánh và tư vấn chọn nhà cung cấp phù hợp nhất
                  </p>
                </div>
                <button className="bg-white text-teal-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Tư vấn miễn phí →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Nhà cung cấp trong nước</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {[
                {
                  company: 'Bảo Việt',
                  pros: ['Thương hiệu Việt Nam uy tín', 'Dễ dàng liên hệ bằng tiếng Việt', 'Giá cả phải chăng'],
                  cons: ['Mạng lưới quốc tế hạn chế', 'Quy trình claim phức tạp hơn'],
                  price: '$50-200',
                  color: 'red'
                },
                {
                  company: 'Liberty Insurance',
                  pros: ['Thuộc tập đoàn quốc tế', 'Hỗ trợ online tiện lợi', 'Bồi thường nhanh'],
                  cons: ['Chưa phổ biến rộng rãi', 'Mức bao phủ không cao'],
                  price: '$80-250',
                  color: 'blue'
                },
                {
                  company: 'PVI Insurance',
                  pros: ['Kinh nghiệm lâu năm', 'Chi nhánh nhiều tỉnh thành', 'Hỗ trợ tận tình'],
                  cons: ['Chậm cập nhật công nghệ', 'Phí cao so với quyền lợi'],
                  price: '$70-220',
                  color: 'green'
                },
                {
                  company: 'MIC Insurance',
                  pros: ['Chuyên nghiệp trong bảo hiểm', 'Quy trình rõ ràng', 'Giá cạnh tranh'],
                  cons: ['Mạng lưới hỗ trợ quốc tế ít', 'Chưa có app di động'],
                  price: '$60-180',
                  color: 'orange'
                }
              ].map((company, index) => (
                <div key={index} className={`bg-white border border-${company.color}-200 rounded-lg p-5`}>
                  <h4 className="text-lg font-bold text-gray-900 mb-3">{company.company}</h4>
                  
                  <div className="space-y-3 mb-4">
                    <div>
                      <h5 className="text-sm font-semibold text-green-600 mb-1">Ưu điểm:</h5>
                      <ul className="text-xs text-gray-700 space-y-1">
                        {company.pros.map((pro, idx) => (
                          <li key={idx}>• {pro}</li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-semibold text-red-600 mb-1">Nhược điểm:</h5>
                      <ul className="text-xs text-gray-700 space-y-1">
                        {company.cons.map((con, idx) => (
                          <li key={idx}>• {con}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  
                  <div className={`bg-${company.color}-50 px-3 py-2 rounded text-center`}>
                    <span className={`text-sm font-medium text-${company.color}-700`}>
                      Giá: {company.price}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">So sánh nhà cung cấp chi tiết</h3>
            
            <div className="overflow-x-auto mb-8">
              <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-sm font-medium text-gray-900">Nhà cung cấp</th>
                    <th className="px-4 py-3 text-center text-sm font-medium text-gray-900">Bao phủ tối đa</th>
                    <th className="px-4 py-3 text-center text-sm font-medium text-gray-900">Hỗ trợ 24/7</th>
                    <th className="px-4 py-3 text-center text-sm font-medium text-gray-900">Claim online</th>
                    <th className="px-4 py-3 text-center text-sm font-medium text-gray-900">Giá từ</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {[
                    { name: 'Allianz', coverage: '$1M', support: true, online: true, price: '$150', rating: 4.8 },
                    { name: 'World Nomads', coverage: '$500K', support: true, online: true, price: '$100', rating: 4.6 },
                    { name: 'IMG Global', coverage: '$2M', support: true, online: true, price: '$80', rating: 4.5 },
                    { name: 'Generali', coverage: '$750K', support: true, online: false, price: '$120', rating: 4.4 },
                    { name: 'Bảo Việt', coverage: '$100K', support: false, online: false, price: '$50', rating: 3.8 }
                  ].map((provider, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">
                        {provider.name}
                        <div className="flex items-center gap-1 mt-1">
                          {Array.from({ length: 5 }, (_, i) => (
                            <i key={i} className={`ri-star-${i < Math.floor(provider.rating) ? 'fill' : 'line'} text-yellow-400 text-xs`}></i>
                          ))}
                          <span className="text-xs text-gray-500 ml-1">{provider.rating}</span>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-sm text-center font-semibold text-gray-900">{provider.coverage}</td>
                      <td className="px-4 py-3 text-sm text-center">
                        {provider.support ? (
                          <i className="ri-check-line text-green-600 text-lg"></i>
                        ) : (
                          <i className="ri-close-line text-red-600 text-lg"></i>
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-center">
                        {provider.online ? (
                          <i className="ri-check-line text-green-600 text-lg"></i>
                        ) : (
                          <i className="ri-close-line text-red-600 text-lg"></i>
                        )}
                      </td>
                      <td className="px-4 py-3 text-sm text-center font-semibold text-blue-600">{provider.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="bg-green-50 border-l-4 border-green-600 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-green-900 mb-2">🎯 Khuyến nghị chuyên gia</h4>
              <p className="text-sm text-gray-700 mb-0">
                Ưu tiên chọn <strong>nhà cung cấp quốc tế</strong> như Allianz, World Nomads khi du lịch Mỹ. Họ có mạng lưới hỗ trợ tốt hơn, quy trình bồi thường nhanh chóng và được các bệnh viện Mỹ tin tưởng. Chi phí cao hơn một chút nhưng đáng đồng tiền.
              </p>
            </div>
          </div>
        )}

        {activeTab === 'claims' && (
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Quy trình bồi thường & xử lý claim</h2>
            
            <div className="w-full h-80 rounded-xl overflow-hidden mb-8">
              <img
                src="https://readdy.ai/api/search-image?query=Insurance%20claims%20process%20documentation%20scene%20with%20medical%20reports%20hospital%20bills%20and%20insurance%20claim%20forms%20on%20desk%2C%20professional%20staff%20reviewing%20paperwork%20with%20computer%20showing%20online%20claim%20system%2C%20organized%20office%20environment%20with%20filing%20cabinets&width=1200&height=500&seq=claims-process&orientation=landscape"
                alt="Quy trình bồi thường"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="bg-red-50 border border-red-200 rounded-xl p-6 mb-8">
              <h3 className="text-lg font-bold text-red-900 mb-3">🚨 Điều đầu tiên khi gặp sự cố</h3>
              <div className="space-y-3">
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 bg-red-600 text-white text-xs font-bold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">1</span>
                  <p className="text-sm text-gray-700">
                    <strong>Liên hệ hotline 24/7 ngay lập tức</strong> - Số điện thoại có trong thẻ bảo hiểm
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 bg-red-600 text-white text-xs font-bold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">2</span>
                  <p className="text-sm text-gray-700">
                    <strong>Không tự ý thanh toán</strong> trước khi có sự đồng ý của bảo hiểm (trừ cấp cứu)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-6 h-6 bg-red-600 text-white text-xs font-bold rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">3</span>
                  <p className="text-sm text-gray-700">
                    <strong>Chụp ảnh, lưu giữ tất cả giấy tờ</strong> - Hóa đơn, báo cáo y tế, biên bản...
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Quy trình xử lý claim từng bước</h3>
            
            <div className="space-y-6 mb-8">
              {[
                {
                  step: 1,
                  title: 'Báo cáo sự cố ngay lập tức',
                  timeframe: 'Trong vòng 24-48 giờ',
                  color: 'red',
                  icon: 'ri-phone-line',
                  actions: [
                    'Gọi hotline 24/7 của công ty bảo hiểm',
                    'Cung cấp số hợp đồng và thông tin cá nhân',
                    'Mô tả chi tiết tình huống xảy ra',
                    'Nhận mã số claim để theo dõi'
                  ],
                  tips: [
                    'Lưu lại số mã claim cẩn thận',
                    'Ghi lại tên nhân viên tư vấn',
                    'Hỏi rõ danh sách giấy tờ cần nộp'
                  ]
                },
                {
                  step: 2,
                  title: 'Thu thập & chuẩn bị hồ sơ',
                  timeframe: 'Trong vòng 7-30 ngày',
                  color: 'orange',
                  icon: 'ri-file-list-line',
                  actions: [
                    'Lấy báo cáo y tế từ bệnh viện/phòng khám',
                    'Thu thập hóa đơn, biên lai thanh toán',
                    'Chụp ảnh vết thương, tài sản bị hư hỏng',
                    'Lấy báo cáo cảnh sát (nếu có)'
                  ],
                  tips: [
                    'Giữ bản gốc, nộp bản sao có chứng thực',
                    'Dịch thuật sang tiếng Anh nếu cần',
                    'Sắp xếp giấy tờ theo thứ tự thời gian'
                  ]
                },
                {
                  step: 3,
                  title: 'Nộp hồ sơ bồi thường',
                  timeframe: 'Online hoặc gửi bưu điện',
                  color: 'blue',
                  icon: 'ri-send-plane-line',
                  actions: [
                    'Điền đầy đủ form claim online/offline',
                    'Upload hoặc gửi tất cả giấy tờ yêu cầu',
                    'Kiểm tra kỹ thông tin trước khi gửi',
                    'Nhận biên lai xác nhận đã nộp hồ sơ'
                  ],
                  tips: [
                    'Double-check mọi thông tin trong form',
                    'Gửi bằng đường có tracking number',
                    'Giữ lại copy toàn bộ hồ sơ đã nộp'
                  ]
                },
                {
                  step: 4,
                  title: 'Xét duyệt và thẩm định',
                  timeframe: '15-45 ngày làm việc',
                  color: 'purple',
                  icon: 'ri-search-line',
                  actions: [
                    'Công ty bảo hiểm xem xét hồ sơ',
                    'Có thể yêu cầu bổ sung thêm giấy tờ',
                    'Thẩm định giá trị thiệt hại',
                    'Quyết định mức bồi thường'
                  ],
                  tips: [
                    'Theo dõi tiến độ qua website/app',
                    'Trả lời nhanh chóng nếu có yêu cầu bổ sung',
                    'Giữ liên lạc thường xuyên với nhân viên phụ trách'
                  ]
                },
                {
                  step: 5,
                  title: 'Nhận bồi thường',
                  timeframe: '5-10 ngày sau phê duyệt',
                  color: 'green',
                  icon: 'ri-bank-card-line',
                  actions: [
                    'Nhận thông báo kết quả bồi thường',
                    'Xác nhận thông tin tài khoản nhận tiền',
                    'Ký xác nhận nhận bồi thường (nếu cần)',
                    'Kiểm tra số tiền đã nhận'
                  ],
                  tips: [
                    'Đọc kỹ thông báo kết quả bồi thường',
                    'Kiểm tra số tiền có đúng như thỏa thuận',
                    'Lưu giữ giấy tờ bồi thường làm chứng từ'
                  ]
                }
              ].map((step, index) => (
                <div key={index} className={`bg-white border-l-4 border-${step.color}-500 rounded-r-xl p-6 shadow-sm`}>
                  <div className="flex items-start gap-4 mb-4">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${step.color}-100 rounded-xl flex-shrink-0`}>
                      <i className={`${step.icon} text-2xl text-${step.color}-600`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <span className={`w-8 h-8 bg-${step.color}-600 text-white text-sm font-bold rounded-full flex items-center justify-center`}>
                          {step.step}
                        </span>
                        <h4 className="text-lg font-bold text-gray-900">{step.title}</h4>
                      </div>
                      <p className={`text-sm font-medium text-${step.color}-600 mb-3`}>{step.timeframe}</p>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <h5 className="text-sm font-bold text-gray-900 mb-2">📋 Các bước thực hiện</h5>
                      <ul className="space-y-2">
                        {step.actions.map((action, idx) => (
                          <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                            <i className={`ri-check-line text-${step.color}-600 text-sm mt-0.5`}></i>
                            <span>{action}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div>
                      <h5 className="text-sm font-bold text-gray-900 mb-2">💡 Mẹo quan trọng</h5>
                      <ul className="space-y-2">
                        {step.tips.map((tip, idx) => (
                          <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                            <i className="ri-lightbulb-line text-yellow-500 text-sm mt-0.5"></i>
                            <span>{tip}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-indigo-600 to-purple-700 rounded-xl p-8 text-white mb-8">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="flex-1 min-w-64">
                  <h3 className="text-xl font-bold mb-2">Hỗ trợ claim 24/7</h3>
                  <p className="text-sm text-white/90">
                    Đội ngũ chuyên gia hỗ trợ xử lý claim nhanh chóng, tối đa hóa mức bồi thường cho khách hàng
                  </p>
                </div>
                <button className="bg-white text-indigo-700 px-8 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer">
                  Liên hệ hỗ trợ →
                </button>
              </div>
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Tình huống thực tế & cách xử lý</h3>
            
            <div className="space-y-4 mb-8">
              {[
                {
                  situation: '🚗 Tai nạn xe thuê tại California',
                  damage: 'Thiệt hại: $25,000',
                  process: [
                    'Báo cảnh sát ngay tại hiện trường',
                    'Chụp ảnh hiện trường và xe hỏng',
                    'Gọi hotline bảo hiểm trong 2 giờ',
                    'Không thừa nhận lỗi với bên thứ 3',
                    'Lấy báo cáo cảnh sát và thông tin đối phương'
                  ],
                  result: 'Bồi thường 100% sau 30 ngày',
                  color: 'red'
                },
                {
                  situation: '🏥 Cấp cứu tim tại Las Vegas',
                  damage: 'Chi phí: $85,000',
                  process: [
                    'Bệnh viện liên hệ trực tiếp với bảo hiểm',
                    'Bảo hiểm ủy quyền thanh toán ngay',
                    'Không cần đặt cọc hoặc trả trước',
                    'Bảo hiểm cover 100% chi phí y tế',
                    'Hỗ trợ vé máy bay về nước cho người thân'
                  ],
                  result: 'Thanh toán trực tiếp, không cần advance',
                  color: 'blue'
                },
                {
                  situation: '✈️ Hủy chuyến đi do Covid',
                  damage: 'Tổn thất: $12,000',
                  process: [
                    'Báo bảo hiểm ngay khi có kết quả dương tính',
                    'Lấy giấy xét nghiệm chính thức',
                    'Hủy các dịch vụ đã đặt với lý do y tế',
                    'Thu thập hóa đơn các chi phí không hoàn',
                    'Nộp hồ sơ đầy đủ trong 30 ngày'
                  ],
                  result: 'Bồi thường 85% theo điều khoản hợp đồng',
                  color: 'orange'
                },
                {
                  situation: '🧳 Hành lý thất lạc 5 ngày',
                  damage: 'Chi phí: $2,500',
                  process: [
                    'Báo mất hành lý tại sân bay',
                    'Lấy reference number từ hãng hàng không',
                    'Mua đồ cần thiết và giữ hóa đơn',
                    'Báo bảo hiểm và gửi PIR report',
                    'Claim cho cả hành lý và chi phí khẩn cấp'
                  ],
                  result: 'Bồi thường $1,500 + $800 chi phí khẩn cấp',
                  color: 'green'
                }
              ].map((case_, index) => (
                <div key={index} className={`bg-${case_.color}-50 border border-${case_.color}-200 rounded-xl p-6`}>
                  <div className="flex items-start justify-between mb-4">
                    <div>
                      <h4 className="text-base font-bold text-gray-900 mb-1">{case_.situation}</h4>
                      <p className={`text-sm font-medium text-${case_.color}-600`}>{case_.damage}</p>
                    </div>
                    <span className={`text-xs font-medium px-3 py-1 rounded-full bg-${case_.color}-100 text-${case_.color}-700`}>
                      Case Study
                    </span>
                  </div>
                  
                  <div className="mb-4">
                    <h5 className="text-sm font-bold text-gray-900 mb-2">Các bước đã thực hiện:</h5>
                    <ol className="space-y-1">
                      {case_.process.map((step, idx) => (
                        <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                          <span className={`w-5 h-5 bg-${case_.color}-600 text-white text-xs rounded-full flex items-center justify-center flex-shrink-0 mt-0.5`}>
                            {idx + 1}
                          </span>
                          <span>{step}</span>
                        </li>
                      ))}
                    </ol>
                  </div>
                  
                  <div className={`bg-${case_.color}-100 p-3 rounded-lg`}>
                    <p className="text-sm text-gray-700">
                      <strong className={`text-${case_.color}-700`}>Kết quả:</strong> {case_.result}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-4">Giấy tờ cần thiết cho từng loại claim</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {[
                {
                  claimType: 'Claim Y tế',
                  icon: 'ri-hospital-line',
                  color: 'red',
                  documents: [
                    'Báo cáo y tế chi tiết từ bác sĩ',
                    'Hóa đơn viện phí, thuốc men',
                    'Kết quả xét nghiệm, chụp X-ray',
                    'Giấy ra viện và toa thuốc',
                    'Hóa đơn taxi đi bệnh viện'
                  ]
                },
                {
                  claimType: 'Claim Hủy chuyến',
                  icon: 'ri-plane-line',
                  color: 'blue',
                  documents: [
                    'Giấy chứng nhận y tế về bệnh tình',
                    'Giấy chứng tử (nếu người thân qua đời)',
                    'Hóa đơn vé máy bay, khách sạn đã đặt',
                    'Email xác nhận từ nhà cung cấp dịch vụ',
                    'Chứng từ hủy từ tour operator'
                  ]
                },
                {
                  claimType: 'Claim Hành lý',
                  icon: 'ri-luggage-cart-line',
                  color: 'green',
                  documents: [
                    'PIR report từ hãng hàng không',
                    'Boarding pass và baggage claim ticket',
                    'Danh sách đồ đạc bị mất chi tiết',
                    'Hóa đơn mua đồ khẩn cấp',
                    'Ảnh chụp vali bị hư hỏng'
                  ]
                },
                {
                  claimType: 'Claim Tai nạn',
                  icon: 'ri-car-line',
                  color: 'orange',
                  documents: [
                    'Báo cáo cảnh sát (Police Report)',
                    'Ảnh hiện trường tai nạn',
                    'Thông tin bên thứ 3 liên quan',
                    'Báo cáo từ công ty cho thuê xe',
                    'Hóa đơn sửa chữa hoặc thay thế'
                  ]
                }
              ].map((claim, index) => (
                <div key={index} className={`bg-${claim.color}-50 border border-${claim.color}-200 rounded-xl p-6`}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className={`w-12 h-12 flex items-center justify-center bg-${claim.color}-100 rounded-lg`}>
                      <i className={`${claim.icon} text-2xl text-${claim.color}-600`}></i>
                    </div>
                    <h4 className="text-lg font-bold text-gray-900">{claim.claimType}</h4>
                  </div>
                  
                  <h5 className="text-sm font-bold text-gray-900 mb-3">📄 Giấy tờ bắt buộc:</h5>
                  <ul className="space-y-2">
                    {claim.documents.map((doc, idx) => (
                      <li key={idx} className="text-sm text-gray-700 flex items-start gap-2">
                        <i className={`ri-file-line text-${claim.color}-600 text-sm mt-0.5`}></i>
                        <span>{doc}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
              <h4 className="text-base font-bold text-yellow-900 mb-2">⚠️ Những lỗi thường gặp khi claim</h4>
              <ul className="text-sm text-gray-700 space-y-2 mb-0">
                <li>• <strong>Báo muộn:</strong> Không báo trong 24-48h sẽ ảnh hưởng đến việc bồi thường</li>
                <li>• <strong>Thiếu giấy tờ:</strong> Không có báo cáo y tế, hóa đơn gốc, biên bản cảnh sát</li>
                <li>• <strong>Thông tin sai:</strong> Khai báo không trung thực về nguyên nhân, mức độ thiệt hại</li>
                <li>• <strong>Tự ý thanh toán:</strong> Đồng ý thanh toán trước khi có sự cho phép của bảo hiểm</li>
                <li>• <strong>Không theo dõi:</strong> Không kiểm tra tiến độ xử lý, bỏ lỡ yêu cầu bổ sung</li>
              </ul>
            </div>
          </div>
        )}
      </div>

      {/* Bottom CTA */}
      <div className="mt-12 bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl p-8 text-white">
        <div className="flex items-center justify-between flex-wrap gap-6">
          <div className="flex-1 min-w-64">
            <h3 className="text-xl font-bold mb-2">Cần tư vấn bảo hiểm hoặc hỗ trợ claim?</h3>
            <p className="text-sm text-gray-300">
              Liên hệ chuyên gia bảo hiểm 15 năm kinh nghiệm để được tư vấn miễn phí và hỗ trợ xử lý claim nhanh chóng
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap cursor-pointer">
              Tư vấn bảo hiểm
            </button>
            <button className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
              Hỗ trợ Claim
            </button>
          </div>
        </div>
      </div>
    </article>
  );
}
